
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "MappingBlocks",
  props: {
    components: {
      type: Array as PropType<Array<{ component: any; props?: Record<string, any> }>>,
      default: () => [],
    },
  },
});
